import {
  buildCart,
  buildContext,
  buildFilterSuggestionsGenerator,
  buildInstantProducts,
  buildProductListing,
  buildProductView,
  buildRecentQueriesList,
  buildRedirectionTrigger,
  buildSearch, buildSearchBox
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
} from "@coveo/headless/commerce";
import { getCommerceEngine, saveCartItemsToLocalStorage } from "@DSG/Coveo/Contex/Engine";
import { CoveoHandler } from "@DSG/Store/CoveoHandlerCreator/CoveoHandlerCreator";
import {
  DISPATCH_CART_CONTROLLER,
  DISPATCH_CONTEXT,
  DISPATCH_COVEO_IS_INITIALIZING,
  DISPATCH_FILTER_SUGGESTIONS_CONTROLLER,
  DISPATCH_FILTER_SUGGESTIONS_STATE,
  DISPATCH_INSTANT_PRODUCTS_CONTROLLER,
  DISPATCH_PRODUCT_LISTING_CONTROLLER,
  DISPATCH_PRODUCT_VIEW_CONTROLLER,
  DISPATCH_RECENT_QUERIES_CONTROLLER,
  DISPATCH_REDIRECTION_TRIGGER_CONTROLLER,
  DISPATCH_SEARCH_BOX_CONTROLLER,
  DISPATCH_SEARCH_CONTROLLER,
  DISPATCH_UPDATE_CART_STATE,
  DISPATCH_UPDATE_INSTANT_PRODUCTS_STATE,
  DISPATCH_UPDATE_PRODUCT_LISTING_STATE,
  DISPATCH_UPDATE_REDIRECTION_TRIGGER_STATE,
  DISPATCH_UPDATE_SEARCH_BOX_STATE,
  DISPATCH_UPDATE_SEARCH_STATE
} from "@DSG/Store/Reducer/CoveoCommerceReducer";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
 
export type HandleType = CoveoHandler;

export const initCoveoCommerce: HandleType = async (props) => {
  const { dispatch } = props;
    try {
      dispatch({
          type: DISPATCH_COVEO_IS_INITIALIZING,
          isInitializing: true
      });
      // Initialize the commerce engine
      const engine = await getCommerceEngine();

      // Product Listing
      const productsListing = buildProductListing(engine);
      dispatch({
          type: DISPATCH_PRODUCT_LISTING_CONTROLLER,
          productsListing
      });
      productsListing.subscribe(() => dispatch({
          type: DISPATCH_UPDATE_PRODUCT_LISTING_STATE,
          state: productsListing.state
      }));

      // Product View
      const productView = buildProductView(engine);
      dispatch({
            type: DISPATCH_PRODUCT_VIEW_CONTROLLER,
            productView
     });

      // Search
      const coveoSearch = buildSearch(engine);
      dispatch({
          type: DISPATCH_SEARCH_CONTROLLER,
          coveoSearch
      });
      
      coveoSearch.subscribe(() => {
          // if(preventCoveoSearchStateUpdates(coveoSearch, coveoSearch.state)) { return; }
          dispatch({
              type: DISPATCH_UPDATE_SEARCH_STATE,
              state: coveoSearch.state
          });
      });

      // Search Box
      const searchBoxId = "search-box";
      const coveoSearchBox = buildSearchBox(engine, {
          options: {
              id: searchBoxId,
              highlightOptions: {
                  correctionDelimiters: {
                      open: '<i>',
                      close: '</i>',
                  },
                  notMatchDelimiters: {
                      open: '<strong>',
                      close: '</strong>',
                  },
              },
          },
      });
      props.dispatch({
          type: DISPATCH_SEARCH_BOX_CONTROLLER,
          coveoSearchBox
      });
      coveoSearchBox.subscribe(() => dispatch({
          type: DISPATCH_UPDATE_SEARCH_BOX_STATE,
          state: coveoSearchBox.state
      }));

      const filterSuggestionsGenerator = buildFilterSuggestionsGenerator(engine);
      dispatch({
          type: DISPATCH_FILTER_SUGGESTIONS_CONTROLLER,
          filterSuggestionsGenerator
      });
      filterSuggestionsGenerator.subscribe(() => dispatch({
          type: DISPATCH_FILTER_SUGGESTIONS_STATE,
          state: filterSuggestionsGenerator.state
      }));
      
      // Instant Products 
      const instantProduct = buildInstantProducts(engine, {
          options: { searchBoxId }
      });
      dispatch({
          type: DISPATCH_INSTANT_PRODUCTS_CONTROLLER,
          instantProduct
      });
      instantProduct.subscribe(() => dispatch({
          type: DISPATCH_UPDATE_INSTANT_PRODUCTS_STATE,
          state: instantProduct.state
      }));
      
      // Recent Queries
      const recentQueries = buildRecentQueriesList(engine);
      dispatch({
          type: DISPATCH_RECENT_QUERIES_CONTROLLER,
          recentQueries
      });
      // recentQueries.subscribe(() => dispatch({
      //     type: DISPATCH_UPDATE_RECENT_QUERIES_STATE,
      //     state: recentQueries.state
      // }));
      
      // Page Context 
      const context = buildContext(engine);
      dispatch({
          type: DISPATCH_CONTEXT,
          context
      });

      // Cart 
      const cart = buildCart(engine);
      dispatch({
          type: DISPATCH_CART_CONTROLLER,
          cart
      });
      cart.subscribe(() => {
          dispatch({
              type: DISPATCH_UPDATE_CART_STATE,
              state: cart.state
          });
          saveCartItemsToLocalStorage(cart.state);
      });

      // Redirection trigger
      const redirectTrigger = buildRedirectionTrigger(engine);
      dispatch({
          type: DISPATCH_REDIRECTION_TRIGGER_CONTROLLER,
          redirectTrigger
      });

      redirectTrigger.subscribe(() => dispatch({
          type: DISPATCH_UPDATE_REDIRECTION_TRIGGER_STATE,
          state: redirectTrigger.state
      }));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error Initializing Coveo Commerce >>", error);
        dispatch({
            type: DISPATCH_COVEO_IS_INITIALIZING,
            isInitializing: false
        });
    }
}
 
export const chain = [initCoveoCommerce];

const initializeCoveoCommerce = createHandlerChainRunnerOptionalParameter(chain, {}, "initializeCoveoCommerce");

export default initializeCoveoCommerce;